import { BaseOverlayComponent } from '../base-overlay/base-overlay.component';
import { TemplateFunction } from '../../../models/template-function.model';
import rtpsOverlayTemplate from './rtps-overlay.component.html';
import { FmcSdk } from 'fmc-sdk';
import { AnyAction } from 'deox';
import { bindEmbeddedFrameEvents } from '../../../util/fmc-helpers/fmc-helpers.util';

export class RtpsOverlayComponent extends BaseOverlayComponent {
  overlayClass = 'rtps-overlay-outer';
  templateFn = rtpsOverlayTemplate;
  fmcSdk: FmcSdk;
  sdkCallbackFnc: (action: AnyAction) => void;

  /**
   * Override this function to change the order or
   * include / exclude specific template functions
   */
  getTemplateFunctions(): TemplateFunction[] {
    return [
      this.templateFn
    ];
  }

  async init(): Promise<void> {
    await super.init();
    const bindFrameEventsResp = bindEmbeddedFrameEvents(this.containerEl, this.store);
    if(!!bindFrameEventsResp){
      this.sdkCallbackFnc = bindFrameEventsResp.sdkMessageCallback;
      this.fmcSdk = bindFrameEventsResp.fmcSdkInstance;
    }
  }
}